import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["label", "inline", "error", "readOnly", "disabled", "required", "containerClassName", "subText", "helpTextClassName", "helpText", "helpTextWidth", "infoPlacement", "infoBadgeClassName", "labelClassName", "inputClassName", "innerRef", "errorClassName", "wrapperDivProps"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import { Input as InputAnt } from 'antd';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import FieldLabel from '../../organisms/FormBuilder/components/fieldLabel';
import styles from './textArea.module.scss';
var TextArea = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TextArea, _React$PureComponent);
  var _super = _createSuper(TextArea);
  function TextArea() {
    var _this;
    _classCallCheck(this, TextArea);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      focus: false
    });
    _defineProperty(_assertThisInitialized(_this), "focusHandler", function () {
      var onFocus = _this.props.onFocus;
      onFocus();
      _this.setState({
        focus: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "blurHandler", function () {
      var onBlur = _this.props.onBlur;
      onBlur();
      _this.setState({
        focus: false
      });
    });
    return _this;
  }
  _createClass(TextArea, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        inline = _this$props.inline,
        error = _this$props.error,
        readOnly = _this$props.readOnly,
        disabled = _this$props.disabled,
        required = _this$props.required,
        containerClassName = _this$props.containerClassName,
        subText = _this$props.subText,
        helpTextClassName = _this$props.helpTextClassName,
        helpText = _this$props.helpText,
        helpTextWidth = _this$props.helpTextWidth,
        infoPlacement = _this$props.infoPlacement,
        infoBadgeClassName = _this$props.infoBadgeClassName,
        labelClassName = _this$props.labelClassName,
        inputClassName = _this$props.inputClassName,
        innerRef = _this$props.innerRef,
        errorClassName = _this$props.errorClassName,
        wrapperDivProps = _this$props.wrapperDivProps,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var wrapperClass = EMPTY_STRING;
      if (readOnly) {
        wrapperClass = cx(wrapperClass, styles.readOnly);
      }
      if (disabled) {
        wrapperClass = cx(wrapperClass, styles.disabled);
      }
      var errorStyles = error && styles.inputError;
      var focus = this.state.focus;
      return /*#__PURE__*/React.createElement("div", _extends({
        className: cx(wrapperClass, styles.inputWrapper, containerClassName)
      }, wrapperDivProps), /*#__PURE__*/React.createElement(FieldLabel, {
        label: label,
        labelClassName: labelClassName,
        required: required,
        helpText: helpText,
        helpTextWidth: helpTextWidth,
        infoPlacement: infoPlacement,
        infoBadgeClassName: infoBadgeClassName
      }), /*#__PURE__*/React.createElement("div", {
        className: cx(styles.input, inputClassName, errorStyles, _defineProperty({}, styles.hasFocus, focus))
      }, /*#__PURE__*/React.createElement(InputAnt.TextArea, _extends({}, rest, {
        ref: innerRef,
        readOnly: readOnly,
        disabled: disabled,
        onFocus: this.focusHandler,
        onBlur: this.blurHandler
      }))), subText && /*#__PURE__*/React.createElement("span", {
        className: styles.warn
      }, subText), error && /*#__PURE__*/React.createElement("span", {
        className: cx(styles.error, errorClassName)
      }, error));
    }
  }]);
  return TextArea;
}(React.PureComponent);
_defineProperty(TextArea, "propTypes", {
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  helpText: PropTypes.string,
  helpTextClassName: PropTypes.string,
  helpTextWidth: PropTypes.string,
  infoPlacement: PropTypes.string,
  infoBadgeClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  wrapperDivProps: PropTypes.object
});
_defineProperty(TextArea, "defaultProps", {
  onFocus: _noop,
  onBlur: _noop,
  helpText: '',
  helpTextClassName: '',
  helpTextWidth: '',
  infoPlacement: undefined,
  infoBadgeClassName: '',
  labelClassName: '',
  inputClassName: '',
  containerClassName: '',
  errorClassName: '',
  wrapperDivProps: null
});
export default TextArea;